import React from "react";
// import Image1 from "../../assets/images/soap-img-2.png";
function Returnfinal() {
  return (
    <section className="return_final_section pt-40 pb-40">
      <div className="container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-lg-10 col-md-12 col-sm-12">
            <div className="row">
              <div className="col-lg-5 col-md-6 col-sm-12 left_col">
                <div className="inner-box">
                  <h5 className="heading_2">Products you send back</h5>
                  <div className="inner-box-one pt-3 pb-3">
                    <div className="products">
                      <div className="img_box">
                        <img 
                        // src={Image1}
                         alt="" />
                      </div>
                      <div className="content_box">
                        <div>
                          <p className="mb-0">Groundnut Oil, 1ltr </p>
                          <div className="price_inner_box">
                            <span>Rs 720</span>
                            <span>Qty: 2</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="products">
                      <div className="img_box">
                        {/* <img src={Image1} alt="" /> */}
                      </div>
                      <div className="content_box">
                        <div>
                          <p className="mb-0">Groundnut Oil, 1ltr </p>
                          <div className="price_inner_box">
                            <span>Rs 720</span>
                            <span>Qty: 2</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="total_refund_inner_box">
                    <h6 className="heading_3">Total Refund</h6>
                    <h6>Rs 1180</h6>
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-md-6 col-sm-12 right_col">
                <div className="inner-box">
                  <h5 className="heading_2">Return summary </h5>
                   <div className="inner-box-one pt-3 pb-3">
                       <p><span>Reason : </span>Product was damaged</p>
                       <p><span>Refund Method  </span>*****856@oksbi</p>
                       <p><span>Pickup Address</span></p>
                       <p>Raghuraj S
                       No.3, Venkatanarayana Road, Trustpuram, Choolaimedu, Coimbatore - 641 056.
                       <span>+91 9412294452</span></p>
                   </div>
                   <div className="button_box text-center">
                    <button className="btn_1_1">Submit return</button>
                   </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Returnfinal;
